CurrentUserService.$inject = ['$ngRedux'];

/**
 * CurrentUserService es un servicio requerido por ui-auth, para poder
 * determinar los roles/permisos del usuario actual.
 */
export default function CurrentUserService($ngRedux) {

  return {
    getPermissions() {
      let user = getUser();
      return user.permisos || [];
    },

    getRols() {
      let user = getUser();

      if (!user.roles) {
        return [];
      }
      return user.roles.map((rol) => rol.name);
    },

    isLoggedIn() {
      return !!getUser().id;
    }
  };


  function getUser() {
    let { currentUser } = $ngRedux.getState();

    if (!currentUser || !currentUser.data) {
      return {};
    }
    return currentUser.data;
  }
}


// WEBPACK FOOTER //
// ./src/core/services/current-user-service.js